module.exports = __webpack_public_path__ + "prod/1.2.3/img/add-icon.c82be472.svg";